<template>
  <b-overlay
    :show="over"
    variant="transparent"
    opacity="0.99"
    blur="5px"
    rounded="sm"
  >
    <template #overlay>
      <div class="text-center">
        <b-icon-controller
          font-scale="3"
          animation="cylon"
        />
        <p id="cancel-label">
          กรุณารอสักครู่...
        </p>
      </div>
    </template>
    <b-card
      no-body
    >
      <b-card-body>
        <div class="d-flex justify-content-between  flex-wrap">
          <b-form-group
            class="mr-1 mb-md-0"
          />
          <!-- <b-form-group
            label="Filter"
            label-cols-sm="2"
            label-align-sm="left"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Type to Search"
              />
              <b-input-group-append>
                <b-button
                  :disabled="!filter"
                  @click="filter = ''"
                >
                  Clear
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group> -->
        </div>
      </b-card-body>
      <b-table
        small
        striped
        hover
        responsive
        show-empty
        class="position-relative items-center"
        :per-page="perPage"
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :filter="filter"
        :filter-included-fields="filterOn"
      >
        <template #empty="scope">
          <div class="p-2 text-center">
            <img
              src="/box.png"
              alt="empty"
              height="40px"
            > {{ scope.emptyFiltered ? 'No matching records found' : 'ไม่พบข้อมูล' }}
          </div>
        </template>
        <template #cell(image)="data">
          <img
            v-if="data.item.image"
            v-b-modal.preview
            :src="`${agent.wallet_endpoint}/img/reviews/${data.item.image}`"
            width="50"
            @click="preview = `${agent.wallet_endpoint}/img/reviews/${data.item.image}`"
          >
        </template>
        <template #cell(rating)="data">
          <b-form-rating
            v-model="data.item.rating"
            variant="warning"
            readonly
          />
        </template>

        <!-- Column: Actions -->
        <template #cell(status)="data">
          <div class="text-nowrap">
            <b-form-checkbox
              v-model="data.item.status"
              class="custom-control-primary"
              name="check-button"
              switch
              :value="1"
              :unchecked-value="0"
              @change="switchEnable(data.item._id,data.item.status)"
            />
          </div>
        </template>
      </b-table>

      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">

        <!-- page length -->
        <b-form-group
          label="Per Page"
          label-cols="8"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
            @change="GetData()"
          />
        </b-form-group>

        <!-- pagination -->
        <div>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
            @input="getData()"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>

    </b-card>

    <div>
      <b-modal
        id="preview"
        size="xs"
        no-body
        centered
      >
        <img
          class="w-100"
          :src="preview"
        >
      </b-modal>
    </div>
  </b-overlay>
</template>

<script>
// import vSelect from 'vue-select'
// import moment from 'moment-timezone'
import Ripple from 'vue-ripple-directive'
import {
  // BModal,
  BCard, BTable,
  // BAvatar,
  BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, VBToggle, BFormCheckbox,
  BFormRating, BOverlay, BIconController,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import moment from 'moment-timezone'

export default {
  components: {
    // vSelect,
    // BModal,
    BCard,
    BTable,
    // BAvatar,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BFormCheckbox,
    BFormRating,
    BOverlay,
    BIconController,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      preview: null,
      perPage: 100,
      pageOptions: [100, 200, 50],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      fields: [
        { key: 'image', label: 'รูป' },
        { key: 'username', label: 'ยูสเซอร์เนม' },
        { key: 'review', label: 'คอมเม้นต์' },
        { key: 'rating', label: 'เรตติ้ง' },
        { key: 'status', label: 'แสดง/ไม่แสดง' },
        {
          key: 'created_at',
          label: 'วันที่คอมเม้นต์',
          formatter: value => moment(value)
            .tz('Asia/Bangkok')
            .format('YYYY-MM-DD HH:mm'),
        },
      ],
      /* eslint-disable global-require */
      items: [],
      over: false,
    }
  },
  computed: {
    agent() {
      return this.$store.state.app.agent
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length
    this.getData()
  },
  methods: {
    switchEnable(id, data) {
      const obj = {
        id,
        status: data,
      }
      this.$http
        .post('/review/switchstatus', obj)
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'บันทึกเรียบร้อย',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'เกิดข้อผิดพลาด',
              icon: 'EditIcon',
              variant: 'danger',
            },
          })
          console.log(error)
        })
    },
    async getData() {
      this.over = true
      try {
        const params = {
          page: this.currentPage,
          per_page: this.perPage,
        }
        const { data: res } = await this.$http.get('/review/index', { params })
        this.items = res.data
        this.totalRows = res.total
      } catch (e) {
        console.debug(e)
        this.over = false
      } finally {
        this.over = false
      }
    },
    makeToast() {
      this.$bvToast.toast('Toast body content', {
        title: 'Variant ',
        variant: 'danger',
        solid: true,
      })
    },
    Success(mes) {
      this.$swal({
        icon: 'success',
        title: '<h3 style="color: #141414">ทำรายการสำเร็จ</h3>',
        text: mes,
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
    },
    SwalError(mes) {
      this.$swal({
        icon: 'error',
        title: '<h3 style="color: #141414">เกิดข้อผิดพลาด!</h3>',
        text: mes,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      })
    },
  },
}
</script>
